import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class ChangeSpeciesLabelAction extends AbstractAction {
    constructor(provider, label) {
        super(provider);

        this.label = label;
        this.oldKeys = Array.from(this.label.keys);
        this.newKeys = Array.from(this.label.keys);
    }

    update(key, checked) {
        if (checked) {
            this.label.showKey(key);
        } else {
            this.label.hideKey(key);
        }
        this.newKeys = Array.from(this.label.keys);
    }

    finish() {
        if (this.oldKeys != this.newKeys) {
              this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
            super.finish();
        } else {
            super.discard();
        }
    }

    undo() {
        this.label.keys = Array.from(this.oldKeys);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
    }

    redo() {
        this.label.keys = Array.from(this.newKeys);
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
    }
}
